module.exports = __webpack_public_path__ + "img/aepps.e686bd68.svg";